"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "belforte-monferrato": {
    "9d9fefeb": [{
      "hkey": "45ecd925",
      "slug": "belforte-monferrato",
      "name": "Belforte Monferrato",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "45ecd925",
      "slug": "belforte-monferrato",
      "name": "Belforte Monferrato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8a4577e1": [{
      "hkey": "45ecd925",
      "slug": "belforte-monferrato",
      "name": "Belforte Monferrato",
      "primary": true,
      "skipSearch": false
    }],
    "santo-criste": [{
      "hkey": "45ecd925",
      "slug": "belforte-monferrato",
      "name": "Belforte Monferrato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d178b6da": [{
      "hkey": "45ecd925",
      "slug": "belforte-monferrato",
      "name": "Belforte Monferrato",
      "primary": true,
      "skipSearch": false
    }],
    "san-criste-gnocchetto": [{
      "hkey": "45ecd925",
      "slug": "belforte-monferrato",
      "name": "Belforte Monferrato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;